import React from 'react'
import {TruncateAndTooltip} from 'mailup-web-components'

const SegmentationPanel = ({ title, items }) => {
  return (
    <div className='modal-segmentation__panel'>
      <p className='modal-segmentation__panel__title'>{title}</p>
      <div className='modal-segmentation__panel__box'>
        {items.map((item, index) => (
          <div key={`segmentation-item-${item.id}`} className='modal-segmentation__panel__box__item'>
            {!item.deleted
              ? <i> <TruncateAndTooltip text={item.name}/></i>
              : <TruncateAndTooltip text={(item.id > 0 && `${item.id} - `) + item.name}/>}

          </div>))}
      </div>

    </div>
  )
}

export default SegmentationPanel
